<template>
  <div class="flex justify-end items-center">
    <p class="numLikes">{{totalVotes}}</p>
    <button class="focus:outline-none" @click="voteParticipation">
      <StarFullIcon class="star star-full" v-if="voted" />
      <StarEmptyIcon class="star" v-else />
    </button>
  </div>
</template>

<script>
// @ is an alias to /src
import StarEmptyIcon from '@/components/StarEmptyIcon.vue'
import StarFullIcon from '@/components/StarFullIcon.vue'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import ApiService from '../services/ApiService'

export default {
  name: 'LikeButton',
  props: {
    participation: {
      type: Object,
      required: true
    }
  },
  components: {
    StarEmptyIcon,
    StarFullIcon
  },
  computed: {
    ...mapState(['email', 'token', 'idContest', 'videoId']),
    ...mapGetters(['getPrimary', 'isLogged', 'getVoteTrans']),
    totalVotes () {
      return this.participation.cms_votes.length
    },
    voted () {
      return this.participation.cms_votes.some(element => element === this.email)
    }
  },
  methods: {
    ...mapMutations(['changeLoading', 'setVideoId']),
    ...mapActions(['getParticipations', 'getParticipation']),
    async voteParticipation () {
      if (this.isLogged) {
        this.changeLoading(true)
        const dataToSend = {
          data: {
            id: this.idContest,
            id_participation: this.participation._id,
            email: this.email,
            vote: this.voted ? 0 : 1
          },
          token: this.token
        }
        try {
          const response = await ApiService.updateVote(dataToSend)
          if (response.data.code === 200) {
            const swalMessage = dataToSend.data.vote ? this.getVoteTrans.vote : this.getVoteTrans.unvote
            if (this.videoId) {
              this.setVideoId(this.$route.params.video_id)
              const params = {
                videoId: this.$route.params.video_id,
                alias_url: this.$route.params.alias_url,
                preview: this.$route.params.preview === 'preview' ? this.$route.params.preview : ''
              }
              this.getParticipation(params)
            } else {
              const params = {
                alias_url: this.$route.params.alias_url,
                preview: this.$route.params.preview === 'preview' ? this.$route.params.preview : ''
              }
              this.getParticipations(params)
            }
            this.$swal({
              icon: 'success',
              title: `${swalMessage}`,
              confirmButtonColor: this.getPrimary,
              confirmButtonText: '<i class="fa fa-check"></i> Ok'
            })
            this.changeLoading(false)
          } else if (response.data.code === 404) {
            this.$swal({
              icon: 'error',
              title: this.getVoteTrans.contest_ended,
              confirmButtonColor: this.getPrimary,
              confirmButtonText: '<i class="fa fa-check"></i> Ok'
            })
            this.$router.push('/')
            this.changeLoading(false)
          } else if (response.data.code === 401) {
            this.$swal({
              icon: 'error',
              title: this.getVoteTrans.need_register,
              confirmButtonColor: this.getPrimary,
              confirmButtonText: '<i class="fa fa-check"></i> Ok'
            })
            // localStorage.removeItem('session')
            this.changeLoading(false)
          }
        } catch (error) {
          this.apiError = true
          this.apiErrorMessage = this.getVoteTrans.api_error
          this.changeLoading(false)
        }
      } else {
        this.$vfm.show('loginModal')
      }
    }
  }
}
</script>

<style scoped>
.numLikes {
  font-weight: 600;
  margin-right: 0.5rem;
}
.star:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.star-full {
  color: var(--star);
}
:deep(.swal2-confirm.swal2-styled.swal2-default-outline):focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
:deep(.swal2-confirm.swal2-styled.swal2-default-outline):focus-visible {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
</style>
